import React from "react";

import "../assets/css/shopper.scss";

const ShopperApproved = () => {
  let sa_review_count = 1,
    sa_date_format = "F j, Y";

  const [isCssLoading, setCssLoading] = React.useState(false);

  React.useEffect(() => {
    setCssLoading(true);
    saLoadScript(
      "https://www.shopperapproved.com/merchant/25061.js?sa_review_count=3"
    );
    setTimeout(() => {
      // Check if the ShopperApproved API is loaded
      if (window.SHOPPER_APPROVED && typeof window.SHOPPER_APPROVED.init === 'function') {
        window.SHOPPER_APPROVED.init(2);
        if (typeof window.SHOPPER_APPROVED.setReviewCount === 'function') {
          window.SHOPPER_APPROVED.setReviewCount();
        }
      }
    }, 1000);
  }, []);

  const saLoadScript = (src) => {
    var js = window.document.createElement("script");
    js.src = src;
    js.type = "text/javascript";
    document.getElementsByTagName("head")[0].appendChild(js);
    setCssLoading(true);
  };

  return (
    <>
      <div className="row">
        <div className="col-md-12">
          <div id="shopper_review_page">
            <div id="review_header"></div>
            <div id="merchant_page"></div>
            <div id="review_image">
              <a
                href="http://www.shopperapproved.com/reviews/metrotrafficschool.com/"
                target="_blank"
                rel="nofollow"
              ></a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShopperApproved;
